module.exports = __webpack_public_path__ + "static/media/next_section_hover.e0c8b5eb.svg";